import { mapState } from 'vuex'
export default {
  data() {
    return {
      claimAllMissionLoading: false,
      displayClaimAllSuccessful: false
    }
  },
  computed: {
    ...mapState({
      missionsSettings: state => state.activities['mission-reward'].missionsSettings
    }),
    dayInWeek() {
      return {
        0: this.tl('sunday'),
        1: this.tl('monday'),
        2: this.tl('tuesday'),
        3: this.tl('wednesday'),
        4: this.tl('thursday'),
        5: this.tl('friday'),
        6: this.tl('saturday')
      }
    }
  },
  methods: {
    checkIfTodayDateIsAfter(date) {
      if (!date) return true
      const today = this.$dayjs().startOf('day')
      const checkedDate = this.$dayjs(date).endOf('day')
      return checkedDate.isSameOrBefore(today, 'day')
    },
    checkIfDateIsTodayDate(date) {
      if (!date) return true
      const checkedDate = this.$dayjs(date).startOf('day')
      return this.$dayjs(checkedDate).isToday()
    },
    getMissionsTitleByDate(date, type = 'weekly', startDate) {
      const day = this.$dayjs(date)
      if (type === 'weekly') {
        const dayOfWeek = day.day()
        const dayInWeek = this.dayInWeek[dayOfWeek]
        return dayInWeek
      } else if (type === 'monthly' || type === 'event') {
        const dayOfMonth = day.date()
        return this.getOrdinal(dayOfMonth)
      }
      return date
    },
    getOrdinal(number) {
      if (number < 1 || number > 31) {
        return 'Invalid input'
      }

      const suffixes = ['th', 'st', 'nd', 'rd']
      const v = number % 100

      if (v >= 11 && v <= 13) {
        return number + 'th'
      }

      const suffix = suffixes[number % 10] || 'th'
      return number + suffix
    },
    async onClaimAllMissions(missionId) {
      this.claimAllMissionLoading = true
      const response = await this.$store.dispatch(
        'activities/mission-reward/onClaimAllCoins',
        missionId
      )
      if (response) {
        // To get notifications
        this.$store.dispatch('activities/notification/getNotifications')
        // To get player coin balance
        this.$store.dispatch('player/totalBalance')
        await this.onFetchMissions()
        this.displayClaimAllSuccessful = true
        // To make the successful dialog disappear after 1 second
        setTimeout(() => {
          this.displayClaimAllSuccessful = false
        }, 1000)
      }
      this.claimAllMissionLoading = false
    },
    async onFetchMissions() {
      await this.$store.dispatch(
        'activities/mission-reward/getMissionById',
        this.$route.query.mission_id
      )
    },
    onActivitiesGoBack() {
      const missionType = this.$route?.query?.mission_type
      if (missionType && !isNaN(parseInt(missionType))) {
        const list = [
          {
            title: this.tl('weeklyMission'),
            value: 1,
            display: this.missionsSettings?.mission_type_settings?.[1]?.status
          },
          {
            title: this.tl('monthlyMission'),
            value: 2,
            display: this.missionsSettings?.mission_type_settings?.[2]?.status
          },
          {
            title: this.tl('eventTriggerMission'),
            value: 3,
            display: this.missionsSettings?.mission_type_settings?.[3]?.status
          },
          {
            title: this.tl('actionBasedMission'),
            value: 4,
            display: this.missionsSettings?.mission_type_settings?.[4]?.status
          }
        ].filter(el => el.display)
        const findIndex = list.findIndex(el => el.value === parseInt(missionType))
        if (findIndex >= 0) this.$router.push(`/activities?mission_type=${findIndex}`)
        else this.$router.push('/activities')
      }
    }
  }
}
